// jQuery.documentSize, v1.2.4
// Copyright (c) 2015-2017 Michael Heim, Zeilenwechsel.de
// Distributed under MIT license
// http://github.com/hashchange/jquery.documentsize

;( function ( $ ) {
    "use strict";

    // IIFE generating the functions $.documentWidth, $.documentHeight, $.windowWidth, $.windowHeight, and
    // $.scrollbarWidth.
    //
    // These functions need to run feature detections which requires insertion of an iframe ($.documentWidth/Height) and
    // a div ($.scrollbarWidth). The body element in the main document must be available when that happens (ie, the
    // opening body tag must have been parsed).
    //
    // For that reason, the detection does not run instantly - after all, the code might be loaded and run while parsing
    // the head. Instead, detection happens on DOM-ready, or when any of the functions is invoked for the first time.
    // Given the purpose of the functions, they won't be called until after the opening body tag has been parsed.

    var _scrollbarWidth,
        _supportsWindowInnerWidth,
        _supportsSubpixelAccuracy,
        elementNameForDocSizeQuery,
        ieVersion,
        useGetComputedStyle = !! window.getComputedStyle;

    /**
     * @param   {Document} [_document=document]
     * @returns {number}
     */
    $.documentWidth = function ( _document ) {
        var width;

        _document || ( _document = document );

        try {

            if ( elementNameForDocSizeQuery === undefined ) testDocumentScroll();
            width = _document[elementNameForDocSizeQuery].scrollWidth;

        } catch ( e ) {

            // Fallback for unsupported, broken browsers which can't run the behaviour test successfully
            width = guessDocumentSize( "Width", _document );

        }

        return width;
    };

    /**
     * @param   {Document} [_document=document]
     * @returns {number}
     */
    $.documentHeight = function ( _document ) {
        var height;

        _document || ( _document = document );

        try {

            if ( elementNameForDocSizeQuery === undefined ) testDocumentScroll();
            height = _document[elementNameForDocSizeQuery].scrollHeight;

        } catch ( e ) {

            // Fallback for unsupported, broken browsers which can't run the behaviour test successfully
            height = guessDocumentSize( "Height", _document );

        }

        return height;
    };

    /**
     * @param   {string|Object|Window} [options="visual"]  (a) viewport option: strings "visual", "layout" (case-
     *                                                         insensitive), or a hash with a `viewport` property
     *                                                     (b) the window argument
     * @param   {string|Object|Window} [_window=window]    same as first argument; positions for window and viewport
     *                                                     argument are interchangeable
     * @returns {number}
     */
    $.windowWidth = function ( options, _window ) {
        var config = getWindowQueryConfig( arguments );
        return getWindowSize( "Width", config );
    };

    /**
     * @param   {string|Object|Window} [options="visual"]  (a) viewport option: strings "visual", "layout" (case-
     *                                                         insensitive), or a hash with a `viewport` property
     *                                                     (b) the window argument
     * @param   {string|Object|Window} [_window=window]    same as first argument; positions for window and viewport
     *                                                     argument are interchangeable
     * @returns {number}
     */
    $.windowHeight = function ( options, _window ) {
        var config = getWindowQueryConfig( arguments );
        return getWindowSize( "Height", config );
    };

    /**
     * @param   {Window} [_window=window]
     * @returns {number}
     */
    $.pinchZoomFactor = function ( _window ) {

        // Calculate the zoom factor based on the width, not the height. getPinchZoomFactor() does just that.
        //
        // It would be more accurate to use the longest side for the calculation, keeping the effect of rounding errors
        // low (unless the browser supports sub-pixel accuracy anyway).
        //
        // Unfortunately, iOS does not allow that approach. Switching from normal to minimal UI is not reflected in the
        // clientHeight, so the zoom factor would seem to change when the UI disappears (even though in reality, it
        // doesn't). We have to use the width, irrespective of orientation.

        return getPinchZoomFactor( _window );
    };

    /**
     * @returns {number}
     */
    $.scrollbarWidth = browserScrollbarWidth;


    /**
     * Returns the window width or height. Does the actual work of $.windowWidth() and $.windowHeight().
     *
     * Handles minimal UI in iOS properly. Returns the size of either the visual viewport (default) or the layout
     * viewport.
     *
     * Precision:
     *
     * - The maximum rounding error for the visual viewport is +/- 1px.
     * - Layout viewport width is precise.
     * - Layout viewport height would potentially be prone to larger rounding errors (though in practice they rarely
     *   seem to exceed +/- 2px). Additional logic is employed to detect and correct these errors. As a result, the
     *   layout viewport height is precise as well.
     *
     * @param   {string}            dimension  must be "Width" or "Height" (upper case!)
     * @param   {WindowQueryConfig} config
     * @returns {number}
     */
    function getWindowSize ( dimension, config ) {
        var ddeClientHeight, visualSize, zoomFactor, snapToKnownHeight, lBound, uBound,
            _window = config.window,

            scrollbarsConsumeSpace = browserScrollbarWidth() !== 0,
            getLayoutViewportWidth = config.useLayoutViewport && dimension === "Width",

            useClientSize = scrollbarsConsumeSpace || !supportsWindowInnerWidth() || getLayoutViewportWidth,
            size = useClientSize ? _window.document.documentElement[ "client" + dimension ] : getWindowInnerSize( dimension, _window );

        if ( config.useLayoutViewport && ! useClientSize ) {

            // Looking for the layout viewport height on mobile. Calculate it from window.innerHeight and the zoom
            // factor, so as to capture the real height when the browser is in minimal UI on iOS.
            //
            // NB The layout viewport has a size in full CSS pixels (unaffected by zooming, hence no sub pixels).

            visualSize = size;
            zoomFactor = getPinchZoomFactor( _window, { asRange: true } );

            size = Math.round( visualSize * zoomFactor.calculated );

            // Fix rounding errors, caused by the visual height ignoring sub-pixel fractions. If we know we are near a
            // known layout viewport height, use that.
            if ( !supportsSubpixelAccuracy() ) {

                ddeClientHeight =  _window.document.documentElement.clientHeight;

                // In Android, the height we get from ddE.clientHeight and the one calculated from window.innerHeight
                // should be the same, except for rounding errors in the calculation. So basically, we could just set
                // any calculated value to the clientHeight, no matter how large the difference is. (That is, if we even
                // end up here - in some versions of Chrome on Android, for instance, we have sub-pixel accuracy.)
                //
                // Not so in iOS. In minimal UI, the real layout viewport may be larger than the one reported by
                // clientHeight, by about 60px. So we need to impose reasonable limits on what is considered to be near
                // the clientHeight.
                //
                // - If the calculated value is within 3px of the clientHeight, we consider it to be a clear case of a
                //   rounding error.
                // - Alternatively, the clientHeight must be between the theoretical maximum and minimum values of the
                //   computation, assuming maximum rounding errors at every stage.
                // - If we use that range, its upper bound is capped at 30px above the clientHeight - keeping a safe
                //   distance from current minimal UI heights, or possible future ones.

                lBound = ( visualSize - 1 ) * zoomFactor.min;
                uBound = ( visualSize + 1 ) * zoomFactor.max;

                snapToKnownHeight = ( size <= ddeClientHeight + 3 && size >= ddeClientHeight - 3 ) ||
                                    ( lBound <= ddeClientHeight && uBound >= ddeClientHeight && uBound < ddeClientHeight + 30 );

                if ( snapToKnownHeight ) size = ddeClientHeight;

            }
        }

        return size;
    }

    /**
     * Calculates the zoom factor for pinch zooming on mobile. A factor > 1 means that the page is zoomed in (content
     * enlarged).
     *
     * The zoom factor returned here measures the size of the visual viewport with respect to the size of the layout
     * viewport.
     *
     * Ignores page zoom on the desktop (returning a zoom factor of 1). For the distinction between pinch and page zoom,
     * again see Chapter 3 in PPK's book.
     *
     * NB visualViewport.scale, part of the new visualViewport API, is not used here even if available. Browsers usually
     * calculate their zoom level with respect to the ideal layout viewport, not the layout viewport actually in use
     * (see Peter-Paul Koch, The Mobile Web Handbook, Chapter 3: Viewports, Section "Minimum and Maximum Zoom"). So, in
     * Chrome for Android, visualViewport.scale returns that ratio, rather than the isolated effect of zooming into a
     * part of the page.
     *
     * The distinction doesn't matter if the meta viewport tag makes the browser use its ideal viewport anyway
     * (width=device-width, initial-scale=1.0). But it leads to confusing results if, for example, initial-scale is set
     * to values < 1, or if the meta viewport tag is left out altogether. Then, the page shrinks visually _by default_,
     * without the user zooming. The scale reported by the visualViewport API captures the effect and returns a value
     * < 1. However, the pinch zoom factor should remain at 1 because the visual viewport is still identical to the
     * layout viewport - never mind the diminutive size of its content.
     *
     * @param   {Window}  [_window=window]
     * @param   {Object}  [options]
     * @param   {boolean} [options.asRange=false]
     * @returns {number|ZoomAccuracyRange}
     */
    function getPinchZoomFactor ( _window, options ) {
        var ddeClientWidth, windowInnerWidth,
            asRange = options && options.asRange,
            factors = {
                calculated: 1,
                min: 1,
                max: 1
            },
            skip = browserScrollbarWidth() !== 0 || !supportsWindowInnerWidth();

        if ( !skip ) {

            _window || ( _window = window );
            ddeClientWidth = _window.document.documentElement.clientWidth;
            windowInnerWidth = getWindowInnerWidth( _window );

            // Calculate the zoom factor, assuming window.innerWidth is precise (no rounding errors).
            factors.calculated = ddeClientWidth / windowInnerWidth;

            // If requested, determine the minimum and maximum value of the zoom factor in the presence of rounding errors.
            if ( asRange ) {
                if ( supportsSubpixelAccuracy() ) {
                    // No need to take rounding errors into account
                    factors.min = factors.max = factors.calculated;
                } else {
                    factors.min = ddeClientWidth / ( windowInnerWidth + 1 );
                    factors.max = ddeClientWidth / ( windowInnerWidth - 1 );
                }
            }

        }

        return asRange ? factors : factors.calculated;
    }

    /**
     * Handles the argument juggling for $.windowWidth() and $.windowHeight(). Extracts the window and viewport settings
     * from the arguments, applying the defaults (use global window, use visual viewport) where necessary.
     *
     * Examines the first two arguments. The window and the viewport setting can appear in either position,
     * interchangeably. The viewport setting can be passed in as a string, or as part of an options hash,
     * `{ viewport: ... }`.
     *
     * Recognized viewport names are "visual" and "layout" (case-insensitive).
     *
     * @param   {Array|Arguments} args
     * @returns {WindowQueryConfig}
     */
    function getWindowQueryConfig( args ) {
        var isWindowArg0, isOptionArg0, isOptionArg1,

            // Defaults
            _window = window,
            _useVisualViewport = true;

        if ( args && args.length ) {

            // Coerce to a real array
            args = Array.prototype.slice.call( args );

            // Examine the first argument. Cast strings to an options hash with a `viewport` property.
            isWindowArg0 = isWindow( args[0] );
            if( !isWindowArg0 ) args[0] = castStringToViewportOption( args[0] );
            isOptionArg0 = !isWindowArg0 && args[0];

            // Examine the second argument. Again, cast strings to an options hash with a `viewport` property.
            if ( !isOptionArg0 ) args[1] = castStringToViewportOption( args[1] );
            isOptionArg1 = !isOptionArg0 && args[1];

            // Extract window and viewport option, if available.
            if ( isWindowArg0 ) {

                _window = args[0];
                if( isOptionArg1 && args[1].viewport ) _useVisualViewport = isVisualViewport( args[1].viewport );

            } else if ( isOptionArg0 ) {

                if( args[0].viewport ) _useVisualViewport = isVisualViewport( args[0].viewport );
                if ( isWindow( args[1] ) ) _window = args[1];

            } else if ( !args[0] && args[1] ) {

                // First argument was falsy, e.g. undefined, null. Ignore it. But process the second, non-falsy argument.
                if( isOptionArg1 && args[1].viewport ) {
                    _useVisualViewport = isVisualViewport( args[1].viewport );
                } else if ( isWindow( args[1] ) ) {
                    _window = args[1];
                }

            }
        }

        return {
            window: _window,
            useVisualViewport: _useVisualViewport,
            useLayoutViewport: !_useVisualViewport
        };
    }

    /**
     * Checks if the argument is the name of the visual viewport. The check is case-insensitive.
     *
     * Expects a string. Tolerates falsy values, returning false then (argument is not naming the visual viewport).
     * Throws an error for everything else. Also throws an error if the viewport name is a string but not recognized
     * (typo alert).
     *
     * Helper for getWindowQueryConfig().
     *
     * @param   {string} [name]  strings "visual", "layout" (case-insensitive)
     * @returns {boolean}
     */
    function isVisualViewport ( name ) {
        var viewport = isString( name ) && name.toLowerCase();

        if ( name && !viewport ) throw new Error( "Invalid viewport option: " + name );
        if ( viewport && viewport !== "visual" && viewport !== "layout" ) throw new Error( "Invalid viewport name: " + name );

        return viewport === "visual";
    }

    /**
     * Examines a value and casts a string to a hash with a `viewport` property (the string being its value). If the
     * value is not a string, or if the string is empty, it is returned as-is. Helper for getWindowQueryConfig().
     *
     * @param   {*} arg
     * @returns {*}
     */
    function castStringToViewportOption ( arg ) {
        return ( isString( arg ) && arg !== "" ) ? { viewport: arg } : arg;
    }

    /**
     * Checks if the browser supports window.visualViewport.width and window.visualViewport.height, or window.innerWidth
     * and window.innerHeight otherwise.
     *
     * See getWindowInnerSize() for the distinction between the visualViewport API and window.innerWidth/Height.
     *
     * The check is run on demand, rather than up front while loading the component, because the window properties can
     * behave strangely in the early stages of opening a window. The component might be loaded in the document head,
     * which could potentially be early enough to run into these oddities. So we wait until the first call.
     *
     * IE 8 does not support window.innerWidth and .innerHeight. FF has a bug which as only been fixed in FF25 (released
     * 29 Oct 2013). It manifests itself in a fictional return value of 10 for these properties. See
     *
     * - https://developer.mozilla.org/en-US/docs/Web/API/Window.innerWidth
     * - https://developer.mozilla.org/en-US/docs/Web/API/Window.innerHeight
     * - https://bugzilla.mozilla.org/show_bug.cgi?id=641188
     *
     * @returns {boolean}
     */
    function supportsWindowInnerWidth () {
        if ( _supportsWindowInnerWidth === undefined ) _supportsWindowInnerWidth = getWindowInnerWidth() > 10;
        return _supportsWindowInnerWidth;
    }

    /**
     * Does the actual work of $.scrollbarWidth. Protected from external modification. See $.scrollbarWidth for details.
     *
     * Adapted from Ben Alman's scrollbarWidth plugin. See
     * - http://benalman.com/projects/jquery-misc-plugins/#scrollbarwidth
     * - http://jsbin.com/zeliy/1
     *
     * @returns {number}
     */
    function browserScrollbarWidth () {
        var testEl;

        if ( _scrollbarWidth === undefined ) {

            testEl = document.createElement( "div" );
            testEl.style.cssText = "width: 100px; height: 100px; overflow: scroll; position: absolute; top: -500px; left: -500px; margin: 0px; padding: 0px; border: none;";

            document.body.appendChild( testEl );
            _scrollbarWidth = testEl.offsetWidth - testEl.clientWidth;
            document.body.removeChild( testEl );

        }

        return _scrollbarWidth;
    }

    /**
     * Detects which element to use for a document size query (body or documentElement).
     *
     * Sandbox
     * -------
     *
     * The detection is sandboxed in an iframe element created for the purpose. If the iframe window can't be
     * accessed because of some obscure policy restriction or browser bug, the main window and document is used
     * as a fallback.
     *
     * The test is designed to minimize the visual and rendering impact in the test window, in case the fallback
     * should ever be used.
     *
     * Test method
     * -----------
     *
     * We can't test directly which call to use (at least not with an even worse amount of intervention than is
     * already the case, which matters if the iframe is not accessible). But we can work by exclusion.
     *
     * In Chrome (desktop and mobile), Safari (also iOS), and Opera, body.scrollWidth returns the true document
     * width. In Firefox and IE, body.scrollWidth responds to the body content size instead. In those browsers,
     * true document width is returned by document.documentElement.scrollWidth.
     *
     * So we test the behaviour of body.scrollWidth by manipulating the body size, while keeping the document size
     * constant.
     *
     * - We prepare for the test by making sure the body does not display its overflow.
     * - Then we inject a small test element into the body and give it a relative position far outside the viewport.
     *
     * The body size is expanded, but the document size remains unaffected because the body hides the overflowing
     * test element (either outright, or by putting it in a hidden part of the scroll pane). Then we check if
     * body.scrollWidth has responded to the change. From that, we infer the right element to use for a document
     * width query.
     *
     * The function does not return anything. It sets the elementNameForDocSizeQuery in the closure instead.
     */
    function testDocumentScroll () {

        var initialDocumentState, _testEl, initialScrollWidth, responds,

            iframe = createTestIframe(),
            _document = iframe && iframe.contentDocument || document,
            _body = _document.body,
            inIframe = _document !== document;

        // Create a test element which will be used to to expand the body content way to the right.
        _testEl = _document.createElement( "div" );
        _testEl.style.cssText = "width: 1px; height: 1px; position: relative; top: 0px; left: 32000px;";

        // Make sure that the body (but not the window) hides its overflow. Only applies if the iframe is not
        // accessible. The iframe document already contains the required styles.
        if ( ! inIframe ) initialDocumentState = prepareGlobalDocument();

        // Inject the test element, then test if the body.scrollWidth property responds
        initialScrollWidth = _body.scrollWidth;
        _body.appendChild( _testEl );
        responds = initialScrollWidth !== _body.scrollWidth;
        _body.removeChild( _testEl );

        // Restore the overflow settings for window and body
        if ( ! inIframe ) restoreGlobalDocument( initialDocumentState );

        // If body.scrollWidth responded, it reacts to body content size, not document size. Default to
        // ddE.scrollWidth. If it did not react, however, it is linked to the (unchanged) document size.
        elementNameForDocSizeQuery = responds ? "documentElement" : "body";

        if ( iframe ) document.body.removeChild( iframe );

    }

    /**
     * Creates an iframe document with an HTML5 doctype and UTF-8 encoding and positions it off screen. Window size
     * is 500px x 500px. Body and window (document element) are set to overflow: hidden.
     *
     * In case the content document of the iframe can't be accessed for some reason, the function returns undefined.
     * This is unlikely to ever happen, though.
     *
     * @returns {HTMLIFrameElement|undefined}
     */
    function createTestIframe () {
        var iframe = document.createElement( "iframe" ),
            body = document.body;

        iframe.style.cssText = "position: absolute; top: -600px; left: -600px; width: 500px; height: 500px; margin: 0px; padding: 0px; border: none; display: block;";
        iframe.frameborder = "0";

        body.appendChild( iframe );
        iframe.src = 'about:blank';

        if ( !iframe.contentDocument ) return;

        iframe.contentDocument.write( '<!DOCTYPE html><html><head><meta charset="UTF-8"><title></title><style type="text/css">html, body { overflow: hidden; }</style></head><body></body></html>' );

        return iframe;
    }

    /**
     * Makes sure the body (but not the window) hides its overflow. Works with the global document, returns the initial
     * state before manipulation (including properties indicating what has been modified).
     *
     * Used only if iframe creation or access has failed for some reason.
     */
    function prepareGlobalDocument () {
        var ddEStyle, bodyStyle,

            ddE = document.documentElement,
            body = document.body,

            ddEComputedStyles = useGetComputedStyle ? window.getComputedStyle( ddE, null ) : ddE.currentStyle,
            bodyComputedStyles = useGetComputedStyle ? window.getComputedStyle( body, null ) : body.currentStyle,

            ddEOverflowX = ( ddEComputedStyles.overflowX || ddEComputedStyles.overflow || "visible" ).toLowerCase(),
            bodyOverflowX = ( bodyComputedStyles.overflowX || bodyComputedStyles.overflow || "visible" ).toLowerCase(),

            modifyBody = bodyOverflowX !== "hidden",
            modifyDocumentElement = ddEOverflowX === "visible",

            initialState = {
                documentElement: {
                    modified: modifyDocumentElement
                },
                body: {
                    modified: modifyBody
                }
            };

        if ( modifyDocumentElement ) {
            ddEStyle = ddE.style;
            initialState.documentElement.styleOverflowX = ddEStyle.overflowX;
            ddEStyle.overflowX = "auto";
        }

        if ( modifyBody ) {
            bodyStyle = body.style;
            initialState.body.styleOverflowX = bodyStyle.overflowX;
            bodyStyle.overflowX = "hidden";
        }

        return initialState;

    }

    /**
     * Restores the body and documentElement styles to their initial state, which is passed in as an argument. Works
     * with the global document.
     *
     * Used only if iframe creation or access has failed for some reason.
     *
     * @param {Object} previousState  the initial state, as returned by prepareGlobalDocument()
     */
    function restoreGlobalDocument ( previousState ) {

        if ( previousState.documentElement.modified ) document.documentElement.style.overflowX = previousState.documentElement.styleOverflowX;
        if ( previousState.body.modified ) document.body.style.overflowX = previousState.body.styleOverflowX;

    }

    /**
     * Returns a best guess for the window width or height. Used as a fallback for unsupported browsers which are too
     * broken to even run the feature test.
     *
     * The conventional jQuery method of guessing the document size is used here: every conceivable value is queried and
     * the largest one is picked.
     *
     * @param {string}   dimension    accepted values are "Width" or "Height" (capitalized first letter!)
     * @param {Document} [_document]
     */
    function guessDocumentSize( dimension, _document ) {
        var ddE = _document.documentElement;

        return Math.max(
            ddE.body[ "scroll" + dimension ], _document[ "scroll" + dimension ],
            ddE.body[ "offset" + dimension ], _document[ "offset" + dimension ],
            _document[ "client" + dimension ]
        );
    }

    /**
     * Returns window.visualViewport.width if available, or window.innerWidth otherwise.
     *
     * Along the way, the return value is examined to see if the browser supports sub-pixel accuracy (floating-point
     * values).
     *
     * @param   {Window} [_window=window]
     * @returns {number}
     */
    function getWindowInnerWidth ( _window ) {
        return getWindowInnerSize( "Width", _window );
    }

    /**
     * Returns window.visualViewport.height if available, or window.innerHeight otherwise.
     *
     * Along the way, the return value is examined to see if the browser supports sub-pixel accuracy (floating-point
     * values).
     *
     * @param   {Window} [_window=window]
     * @returns {number}
     */
    function getWindowInnerHeight ( _window ) {
        return getWindowInnerSize( "Height", _window );
    }

    /**
     * Returns window.visualViewport.width if available, or window.innerWidth otherwise, for width. Likewise, it
     * returns window.visualViewport.height or window.innerHeight for height. The dimension argument determines whether
     * width or height is returned.
     *
     * Along the way, the return value is examined to see if the browser supports sub-pixel accuracy (floating-point
     * values).
     *
     * If the visualViewport API is available, it is preferred over window.innerWidth/Height. That's because Chrome,
     * from version 62, has changed the behaviour of window.innerWidth/Height, which used to return the size of the
     * visual viewport. In Chrome, it now returns the size of the layout viewport, breaking compatibility with all other
     * browsers and its own past behaviour. Other browsers may follow suit, though. See
     *
     * - https://www.quirksmode.org/blog/archives/2017/09/chrome_breaks_v.html
     * - https://developers.google.com/web/updates/2017/09/visual-viewport-api
     * - https://bugs.chromium.org/p/chromium/issues/detail?id=767388#c8
     *
     * @param   {string} dimension  must be "Width" or "Height" (upper case!)
     * @param   {Window} [_window=window]
     * @returns {number}
     */
    function getWindowInnerSize ( dimension, _window ) {
        var size =  ( _window || window ).visualViewport ?
                    ( _window || window ).visualViewport[ dimension.toLowerCase() ] :
                    ( _window || window )[ "inner" + dimension];

        // Check for fractions. Exclude undefined return values in browsers which don't support window.innerWidth/Height.
        if ( size ) checkForFractions( size );
        return size;
    }

    /**
     * Accepts an observed value of window.innerWidth or window.innerHeight and examines it for fractional values.
     * Caches the finding if there is one. Helper for getWindowInnerWidth() and friends.
     *
     * See supportsSubpixelAccuracy() for more.
     *
     * @param {number} sizeMeasurement
     */
    function checkForFractions ( sizeMeasurement ) {

        // When checking the cached value, we can't accept false as a definitive answer. We have to continue checking
        // unless the cached value is `true`.
        //
        // See supportsSubpixelAccuracy().
        if ( !_supportsSubpixelAccuracy && isFloat( sizeMeasurement ) ) _supportsSubpixelAccuracy = true;

    }

    /**
     * Returns whether or not the browser supports sub-pixel accuracy (floating-point values) for window.innerWidth and
     * window.innerHeight - as far as we know yet.
     *
     * The browser behaviour can't be tested directly, and must be figured out by continuous observation. We have to
     * monitor the return values of window.innerWidth/Height for fractions. That is done with getWindowInnerWidth etc.
     * As soon as we find a fraction, we know that the browser supports floating-point accuracy.
     *
     * However, we can never be sure of the opposite. If we haven't encountered a fraction yet, it could simply mean
     * that we are at 100% zoom, and integers have indeed been the correct return value so far.
     *
     * So when the method here answers with true, it is definitive. When it returns false, that just means "maybe not,
     * but we don't know". And the the return value might flip to true in a future query.
     *
     * @returns {boolean}
     */
    function supportsSubpixelAccuracy () {
        return !!_supportsSubpixelAccuracy;
    }

    function isWindow ( value ) {
        // Identical to jQuery.isWindow()
        return value != null && value.window == value;         // jshint ignore:line
    }

    function isString ( value ) {
        // Done as in the Lodash compatibility build
        return typeof value === 'string' || value && typeof value === 'object' && Object.prototype.toString.call(value) === '[object String]' || false;
    }

    /**
     * Returns whether or not a value is of type number. Also rejects NaN as a number.
     *
     * NB This is not the same as $.isNumeric because $.isNumeric( "3" ) is true while isNumber( "3" ) is false.
     *
     * @param   {*} value
     * @returns {boolean}
     */
    function isNumber ( value ) {
        // Done as in the Lodash compatibility build, but rejecting NaN as a number.
        var isNumeric = typeof value === 'number' || value && typeof value === 'object' && Object.prototype.toString.call( value ) === '[object Number]' || false;

        // Reject NaN before returning
        return isNumeric && value === +value;
    }

    /**
     * Returns whether or not a number is a float, ie has decimals.
     *
     * Requires the argument to be a number. If unsure, guard against false detections with
     * `isNumber( value ) && isFloat ( value )`.
     *
     * For the technique, see http://stackoverflow.com/a/3885844/508355
     *
     * @param   {number} num
     * @returns {boolean}
     */
    function isFloat ( num ) {
        return num === +num && num !== ( num | 0 );         // jshint ignore:line
    }

    /**
     * Returns the IE version, or false if the browser is not IE.
     *
     * The result is determined by browser sniffing, rather than a test tailored to the use case. The function must only
     * be called as a last resort, for scenarios where there is no alternative to browser sniffing.
     *
     * These scenarios include:
     *
     * - Preventing IE6 and IE7 from crashing
     * - Preventing IE9 from blocking or delaying the load event
     *
     * The test follows the MSDN recommendation at https://msdn.microsoft.com/en-us/library/ms537509(v=vs.85).aspx#parsingua
     * The result is cached.
     *
     * @returns {number|boolean}
     */
    function getIEVersion () {
        var userAgent, userAgentTestRx;

        if ( ieVersion === undefined ) {

            ieVersion = false;
            userAgent = navigator && navigator.userAgent;

            if ( navigator && navigator.appName === "Microsoft Internet Explorer" && userAgent ) {
                userAgentTestRx = new RegExp( "MSIE ([0-9]{1,}[\.0-9]{0,})" );                          // jshint ignore:line
                if ( userAgentTestRx.exec( userAgent ) != null ) ieVersion = parseFloat( RegExp.$1 );
            }

        }

        return ieVersion;
    }

    /**
     * Checks if we are dealing with a truly ancient version of IE (< IE8).
     *
     * This is done by browser sniffing, rather than a test tailored to the use case. Use it only if there is no
     * alternative.
     *
     * @returns {boolean}
     */
    function isAncientIE () {
        var ieVersion = getIEVersion();
        return ieVersion && ieVersion < 8;
    }

    /**
     * Checks if the browser is IE9.
     *
     * This is done by browser sniffing, rather than a test tailored to the use case. Use it only if there is no
     * alternative.
     *
     * @returns {boolean}
     */
    function isIE9 () {
        return getIEVersion() === 9;
    }


    // Let's prime $.documentWidth(), $.documentHeight() and $.scrollbarWidth() immediately after the DOM is ready. It
    // is best to do it up front because the test touches the DOM, so let's get it over with before people set up
    // handlers for mutation events and such.
    //
    // This step has to be skipped for the following browsers:
    //
    // - ancient versions of IE (IE6, IE7).
    //   IE6 and IE7 can't handle the feature tests on DOM ready - they crash right away. Later on, the tests are ok.
    //
    // - IE9.
    //   If the feature tests were run on DOM ready, the window load event would become unreliable. The event might not
    //   fire until the user moves the mouse over the document. This bug is rare and not triggered by jQuery.documentSize
    //   alone; third-party code likely plays a role. The exact circumstances are not clear - see issue #3.
    //
    // For these browsers, we don't run the feature tests preemptively. Instead, we do it on demand, when the first
    // document size query is made.
    if ( typeof $ === "function" && !isAncientIE() && !isIE9() ) {

        // Try-catch acts as a safety net for unsupported, broken browsers
        try {

            $( function () {
                if ( elementNameForDocSizeQuery === undefined ) testDocumentScroll();
                browserScrollbarWidth();
            } );

        } catch ( e ) {}

    }


    /**
     * Custom types.
     *
     * For easier documentation and type inference.
     */

    /**
     * @name ZoomAccuracyRange
     * @type {Object}
     *
     * @property {number} calculated
     * @property {number} min
     * @property {number} max
     */

    /**
     * @name WindowQueryConfig
     * @type {Object}
     *
     * @property {Window}  window
     * @property {boolean} useVisualViewport
     * @property {boolean} useLayoutViewport
     */

}(
    typeof jQuery !== "undefined" ? jQuery :
    typeof Zepto !== "undefined" ? Zepto :
    $
));
// jQuery.isInView, v1.0.6
// Copyright (c) 2014-2017 Michael Heim, Zeilenwechsel.de
// Distributed under MIT license
// http://github.com/hashchange/jquery.isinview

;( function( $ ) {
    "use strict";

    var _useGetComputedStyle = !! window.getComputedStyle,          // IE8, my dear, this is for you
        _isIOS,
        root = window,
        $root = $( window );


    /**
     * API
     */

    /**
     * @param   {string} [axis="both"]  values "horizontal", "vertical", "both"
     * @returns {boolean|Object|undefined}
     */
    $.fn.hasScrollbar = function ( axis ) {
        return hasScrollbar( this, axis );
    };

    /**
     * @param   {string} [axis="both"]  values "horizontal", "vertical", "both"
     * @returns {number|Object|undefined}
     */
    $.fn.scrollbarWidth = function ( axis ) {
        return effectiveScrollbarWith( this, axis );
    };

    /**
     * @returns {Window|undefined}
     */
    $.fn.ownerWindow = function () {
        return ownerWindow( this );
    };

    /**
     * @param {Window|Document|HTMLElement|jQuery|string} [container=window]
     * @param {Object}                                    [opts]
     * @param {boolean}                                   [opts.partially=false]
     * @param {boolean}                                   [opts.excludeHidden=false]
     * @param {string}                                    [opts.direction="both"]
     * @param {string}                                    [opts.box="border-box"]     alternatively, "content-box"
     * @param {number|string}                             [opts.tolerance=0]          number only (px), or with unit ("px" or "%" only)
     *
     * @returns {jQuery}
     */
    $.fn.inView = function ( container, opts ) {
        return inView( this, container, opts );
    };

    /**
     * @param {Object}        [opts]
     * @param {boolean}       [opts.partially=false]
     * @param {boolean}       [opts.excludeHidden=false]
     * @param {string}        [opts.direction="both"]
     * @param {string}        [opts.box="border-box"]     alternatively, "content-box"
     * @param {number|string} [opts.tolerance=0]          number only (px), or with unit ("px" or "%" only)
     *
     * @returns {jQuery}
     */
    $.fn.inViewport = function ( opts ) {
        return inView( this, ownerWindow( this ), opts );
    };

    /**
     * @param {Window|Document|HTMLElement|jQuery|string} [container=window]
     * @param {Object}                                    [opts]
     * @param {boolean}                                   [opts.partially=false]
     * @param {boolean}                                   [opts.excludeHidden=false]
     * @param {string}                                    [opts.direction="both"]
     * @param {string}                                    [opts.box="border-box"]     alternatively, "content-box"
     * @param {number|string}                             [opts.tolerance=0]          number only (px), or with unit ("px" or "%" only)
     *
     * @returns {boolean}
     */
    $.fn.isInView = function ( container, opts ) {
        return isInView( this, container, opts );
    };

    /**
     * @param {Object}        [opts]
     * @param {boolean}       [opts.partially=false]
     * @param {boolean}       [opts.excludeHidden=false]
     * @param {string}        [opts.direction="both"]
     * @param {string}        [opts.box="border-box"]     alternatively, "content-box"
     * @param {number|string} [opts.tolerance=0]          number only (px), or with unit ("px" or "%" only)
     *
     * @returns {boolean}
     */
    $.fn.isInViewport = function ( opts ) {
        return isInView( this, ownerWindow( this ), opts );
    };

    $.expr.match.inviewport = /^(?:inVieport)$/i;

    $.expr.setFilters.inviewport = function ( elems, argument, not ) {
        var $elems = $( elems ),
            $elemsInView = inView( $elems, ownerWindow( $elems ) );

        return not ? $elems.not( $elemsInView ) : $elemsInView;
    };

    /**
     * Internals
     */

    /**
     * Does the actual work of $.fn.hasScrollbar. Protected from external modification. See $.fn.hasScrollbar for
     * details.
     *
     * @param   {jQuery} $elem
     * @param   {string} [axis="both"]  values "horizontal", "vertical", "both"
     * @returns {boolean|Object|undefined}
     */
    function hasScrollbar ( $elem, axis ) {

        var $body, elemProps, bodyProps, innerWidth, innerHeight, scrollWidth, scrollHeight,
            query = { target: {} }, result = {}, context = {},
            elem = $elem[0];

        $elem = $elem.eq( 0 );
        axis || ( axis = "both" );

        query.getBoth = axis === "both";
        query.getHorizontal = axis === "horizontal" || query.getBoth;
        query.getVertical = axis === "vertical" || query.getBoth;

        if ( axis !== "horizontal" && axis !== "vertical" && axis !== "both" ) throw new Error( "Invalid parameter value: axis = " + axis );
        if ( ! $elem.length ) return;

        // Transformations:
        // - If called on a window, we need window, document, documentElement and body, and discard the element
        // - If called on the document or document element, we treat it like a call on window (above)
        // - If called on the body, we need document, documentElement and the body itself (again, we discard the element
        //   to avoid ambiguity)
        // - If called on an iframe element, we treat it like a window call, using the iframe content window
        query.target.isWindow = $.isWindow( elem );
        if ( query.target.isWindow ) {
            context.document = elem.document;
        } else if ( elem.nodeType === 9 ) {
            context.document = elem;
            query.target.isWindow = true;
        } else if ( elem === elem.ownerDocument.documentElement ) {
            context.document = elem.ownerDocument;
            query.target.isWindow = true;
        } else if ( elem.nodeType === 1 && elem.tagName.toLowerCase() === "iframe" ) {
            context.document = elem.contentDocument || elem.contentWindow.document;
            query.target.isWindow = true;
        } else if ( elem === elem.ownerDocument.body ) {
            context.document = elem.ownerDocument;
            query.target.isBody = true;
        }

        if ( query.target.isWindow || query.target.isBody ) {
            context.window = context.document.defaultView || context.document.parentWindow;
            context.$document = $( context.document );
            context.documentElement = context.document.documentElement;
            context.body = context.document.body;

            elem = $elem = undefined;       // won't be needed; discard, to avoid ambiguity in the code below
        }

        if ( query.target.isWindow ) {

            result = _windowHasScrollbar( query, context );

        } else if ( query.target.isBody ) {

            // Checking for body scroll bars.
            //
            // body.clientWidth returns the width of the body, minus the scroll bars. We can simply compare it to the
            // full width, provided that the browser displays scroll bars which take up space.
            //
            // By implication, this check DOES NOT work for an effective body overflow of "auto" in browsers which
            // display scroll bars of width 0. (Affects iOS, other mobile browsers, and Safari on OS X when used without
            // an attached mouse.) There simply is no reliable, bullet-proof way to determine the width of the body
            // content, ie the true body scroll width, in those browsers.
            bodyProps = _getViewportOverflows( query, context ).body;

            $body = $( context.body );
            if ( query.getHorizontal ) result.horizontal = bodyProps.overflowScrollX || bodyProps.overflowAutoX && context.body.clientHeight < $body.height();
            if ( query.getVertical ) result.vertical = bodyProps.overflowScrollY || bodyProps.overflowAutoY && context.body.clientWidth < $body.width();

        } else {

            // Scroll bars on an ordinary HTML element
            //
            // If we deal with an ordinary element, we always need the overflow settings for both axes because the axes
            // interact (one scroll bar can cause another).
            elemProps = getCss( elem, ["overflow", "overflowX", "overflowY"], { toLowerCase: true } );
            elemProps = getAppliedOverflows( elemProps, true );

            scrollWidth = elem.scrollWidth;
            scrollHeight = elem.scrollHeight;

            result.horizontal = scrollWidth > 0 && ( elemProps.overflowScrollX || elemProps.overflowAutoX && ( innerWidth = $elem.innerWidth() ) < scrollWidth );
            result.vertical = scrollHeight > 0 && ( elemProps.overflowScrollY || elemProps.overflowAutoY && ( innerHeight = $elem.innerHeight() ) < scrollHeight );

            // Detect if the appearance of one scroll bar causes the other to appear, too.
            result.vertical = result.vertical ||
                              result.horizontal && elemProps.overflowAutoY &&
                              ( innerHeight !== undefined ? innerHeight : $elem.innerHeight() ) - $.scrollbarWidth() < scrollHeight;
            result.horizontal = result.horizontal ||
                                result.vertical && elemProps.overflowAutoX &&
                                ( innerWidth !== undefined ? innerWidth : $elem.innerWidth() ) - $.scrollbarWidth() < scrollWidth;

        }

        return query.getBoth ? result : query.getHorizontal ? result.horizontal : result.vertical;
    }

    /**
     * Does the actual work of $.fn.scrollbarWidth. Protected from external modification. See $.fn.scrollbarWidth for
     * details.
     *
     * @param   {jQuery} $elem
     * @param   {string} [axis="both"]  values "horizontal", "vertical", "both"
     * @returns {number|Object}
     */
    function effectiveScrollbarWith ( $elem, axis ) {

        var queryHorizontal, queryVertical, queryBoth, elemHasScrollbar, horizontal, vertical,
            globalWidth = $.scrollbarWidth();

        axis || ( axis = "both" );

        queryBoth = axis === "both";
        queryHorizontal = axis === "horizontal" || queryBoth;
        queryVertical = axis === "vertical" || queryBoth;

        if ( axis !== "horizontal" && axis !== "vertical" && axis !== "both" ) throw new Error( "Invalid parameter value: axis = " + axis );
        if ( ! $elem.length ) return;

        // Bail out early, without an $elem.hasScrollbar() query, if scroll bars don't take up any space.
        if ( globalWidth === 0 ) return queryBoth ? { horizontal: 0, vertical: 0 } : 0;

        elemHasScrollbar = queryBoth ? hasScrollbar( $elem ) : queryHorizontal ? { horizontal: hasScrollbar( $elem, "horizontal" ) } : { vertical: hasScrollbar( $elem, "vertical" ) };

        if ( queryHorizontal ) horizontal = elemHasScrollbar.horizontal ? globalWidth : 0;
        if ( queryVertical ) vertical = elemHasScrollbar.vertical ? globalWidth : 0;

        return queryBoth ? { horizontal: horizontal, vertical: vertical } : queryHorizontal ? horizontal : vertical;

    }

    /**
     * Does the actual work of $.fn.ownerWindow. Protected from external modification. See $.fn.ownerWindow for details.
     *
     * @param   {jQuery} $elem
     * @returns {Window|undefined}
     */
    function ownerWindow ( $elem ) {
        var elem = $elem[0],
            ownerDocument = elem && ( elem.nodeType === 9 ? elem : elem.ownerDocument );

        return ownerDocument && ( ownerDocument.defaultView || ownerDocument.parentWindow ) || $.isWindow( elem ) && elem || undefined;
    }

    /**
     * Does the actual work of $.fn.inView. Protected from external modification. See $.fn.inView for details.
     *
     * @param {jQuery}                                    $elems
     * @param {Window|Document|HTMLElement|jQuery|string} [container=window]
     * @param {Object}                                    [opts]
     * @param {boolean}                                   [opts.partially=false]
     * @param {boolean}                                   [opts.excludeHidden=false]
     * @param {string}                                    [opts.direction="both"]
     * @param {string}                                    [opts.box="border-box"]     alternatively, "content-box"
     * @param {number|string}                             [opts.tolerance=0]          number only (px), or with unit ("px" or "%" only)
     *
     * @returns {jQuery}
     */
    function inView ( $elems, container, opts ) {

        var config,
            elemsInView = [];

        if ( ! $elems.length ) return $();

        config = _prepareConfig( $elems, container, opts );

        // Check if the elements are children of the container. For performance reasons, only the first element is
        // examined.
        checkHierarchy( $elems[0], config.container );

        $elems.each( function () {
            if ( _isInView( this, config ) ) elemsInView.push( this );
        } );

        return $( elemsInView );

    }

    /**
     * Does the actual work of $.fn.isInView. Protected from external modification. See $.fn.isInView for details.
     *
     * @param {jQuery}                                    $elem
     * @param {Window|Document|HTMLElement|jQuery|string} [container=window]
     * @param {Object}                                    [opts]
     * @param {boolean}                                   [opts.partially=false]
     * @param {boolean}                                   [opts.excludeHidden=false]
     * @param {string}                                    [opts.direction="both"]
     * @param {string}                                    [opts.box="border-box"]     alternatively, "content-box"
     * @param {number|string}                             [opts.tolerance=0]          number only (px), or with unit ("px" or "%" only)
     *
     * @returns {boolean}
     */
    function isInView ( $elem, container, opts ) {

        var config,
            elem = $elem[0];

        if ( ! $elem.length ) return false;

        config = _prepareConfig( $elem, container, opts );
        checkHierarchy( elem, config.container );

        return _isInView( elem, config );

    }

    /**
     * Prepares the configuration for a single element query. Returns the config object which is to be consumed by
     * _isInView().
     *
     * @param {jQuery}                                    $elem                       single element, or set of elements
     * @param {Window|Document|HTMLElement|jQuery|string} [container=window]
     * @param {Object}                                    [opts]
     * @param {boolean}                                   [opts.partially=false]
     * @param {boolean}                                   [opts.excludeHidden=false]
     * @param {string}                                    [opts.direction="both"]
     * @param {string}                                    [opts.box="border-box"]     alternatively, "content-box"
     * @param {number|string}                             [opts.tolerance=0]          number only (px), or with unit ("px" or "%" only)
     *
     * @returns {Object}
     */
    function _prepareConfig ( $elem, container, opts ) {

        var $container, direction,
            config = {};

        opts || ( opts = {} );

        container || ( container = ownerWindow( $elem ) );
        config.$container = $container = wrapContainer( container );
        config.container = container = $container[0];

        checkOptions( opts );

        direction = opts.direction || 'both';
        config.useVertical = direction === 'both' || direction === 'vertical';
        config.useHorizontal = direction === 'both' || direction === 'horizontal';

        config.partially = opts.partially;
        config.excludeHidden = opts.excludeHidden;
        config.borderBox = opts.box !== 'content-box';
        config.containerIsWindow = $.isWindow( container );

        if ( opts.tolerance !== undefined ) {
            config.toleranceType = ( isNumber( opts.tolerance ) || opts.tolerance.slice( -3 ) === "px" ) ? "add" : "multiply";
            config.tolerance = config.toleranceType === "add" ? parseFloat( opts.tolerance ) : parseFloat( opts.tolerance ) / 100 + 1;
        } else {
            config.tolerance = 0;
            config.toleranceType = "add";
        }

        // Create an object to cache DOM queries with regard to the viewport, for faster repeated access.
        config.cache = {};

        return config;
    }

    /**
     * Returns if an element is in view, with regard to a given configuration.
     *
     * The configuration is built with _prepareConfig().
     *
     * @param {HTMLElement}        elem
     * @param {Object}             config
     * @param {HTMLElement|Window} config.container
     * @param {jQuery}             config.$container
     * @param {boolean}            config.containerIsWindow
     * @param {Object}             config.cache
     * @param {boolean}            config.useHorizontal
     * @param {boolean}            config.useVertical
     * @param {boolean}            config.partially
     * @param {boolean}            config.excludeHidden
     * @param {boolean}            config.borderBox
     * @param {number}             config.tolerance
     * @param {string}             config.toleranceType
     *
     * @returns {boolean}
     */
    function _isInView ( elem, config ) {

        var containerWidth, containerHeight, hTolerance, vTolerance, rect,
            container = config.container,
            $container = config.$container,
            cache = config.cache,
            elemInView = true;

        if ( elem === container ) throw new Error( "Invalid container: is the same as the element" );

        // When hidden elements are ignored, we check if an element consumes space in the document. And we bail out
        // immediately if it doesn't.
        //
        // The test employed for this works in the vast majority of cases, but there is a limitation. We use offsetWidth
        // and offsetHeight, which considers the content (incl. borders) but ignores margins. Zero-size content with a
        // margin might actually consume space sometimes, but it won't be detected (see http://jsbin.com/tiwabo/3).
        //
        // That said, the definition of visibility and the actual test are the same as in jQuery :visible.
        if ( config.excludeHidden && !( elem.offsetWidth > 0 && elem.offsetHeight > 0 ) ) return false;

        if ( config.useHorizontal ) containerWidth = getNetContainerWidth( $container, config.containerIsWindow, cache );
        if ( config.useVertical ) containerHeight = getNetContainerHeight( $container, config.containerIsWindow, cache );

        // Convert tolerance to a px value (if given as a percentage)
        hTolerance = cache.hTolerance !== undefined ? cache.hTolerance : ( cache.hTolerance = config.toleranceType === "add" ? config.tolerance : containerWidth * config.tolerance );
        vTolerance = cache.vTolerance !== undefined ? cache.vTolerance : ( cache.vTolerance = config.toleranceType === "add" ? config.tolerance : containerHeight * config.tolerance );

        // We can safely use getBoundingClientRect without a fallback. Its core properties (top, left, bottom, right)
        // are supported on the desktop for ages (IE5+). On mobile, too: supported from Blackberry 6+ (2010), iOS 4
        // (2010, iPhone 3GS+), according to the jQuery source comment in $.fn.offset.
        //
        // In oldIE (up to IE8), the coordinates were 2px off in each dimension because the "viewport" began at (2,2) of
        // the window. Can be feature-tested by creating an absolutely positioned div at (0,0) and reading the rect
        // coordinates. Won't be fixed here because the quirk is too minor to justify the overhead, just for oldIE.
        //
        // (See http://stackoverflow.com/a/10231202/508355 and Zakas, Professional Javascript (2012), p. 406)

        rect = config.borderBox ? elem.getBoundingClientRect() : getContentRect( elem );
        if ( ! config.containerIsWindow ) rect = getRelativeRect( rect, $container, cache );

        if ( config.partially ) {
            if ( config.useVertical ) elemInView = rect.top < containerHeight + vTolerance && rect.bottom > -vTolerance;
            if ( config.useHorizontal ) elemInView = elemInView && rect.left < containerWidth + hTolerance && rect.right > -hTolerance;
        } else {
            if ( config.useVertical ) elemInView = rect.top >= -vTolerance && rect.top < containerHeight + vTolerance && rect.bottom > -vTolerance && rect.bottom <= containerHeight + vTolerance;
            if ( config.useHorizontal ) elemInView = elemInView && rect.left >= -hTolerance && rect.left < containerWidth + hTolerance && rect.right > -hTolerance && rect.right <= containerWidth + hTolerance;
        }

        return elemInView;

    }

    /**
     * Gets the TextRectangle coordinates relative to a container element.
     *
     * Do not call if the container is a window (redundant) or a document. Both calls would fail.
     */
    function getRelativeRect ( rect, $container, cache ) {
        var containerPaddingRectRoot;

        if ( cache && cache.containerPaddingRectRoot ) {

            containerPaddingRectRoot = cache.containerPaddingRectRoot;

        } else {
            // gBCR coordinates enclose padding, and leave out margin. That is perfect for scrolling because
            //
            // - padding scrolls (ie,o it is part of the scrollable area, and gBCR puts it inside)
            // - margin doesn't scroll (ie, it pushes the scrollable area to another position, and gBCR records that)
            //
            // Borders, however, don't scroll, so they are not part of the scrollable area, but gBCR puts them inside.
            //
            // (See http://jsbin.com/pivata/10 for an extensive test of gBCR behaviour.)

            containerPaddingRectRoot = getPaddingRectRoot( $container[0] );

            // Cache the calculations
            if ( cache ) cache.containerPaddingRectRoot = containerPaddingRectRoot;
        }

        return {
            top: rect.top - containerPaddingRectRoot.top,
            bottom: rect.bottom - containerPaddingRectRoot.top,
            left: rect.left - containerPaddingRectRoot.left,
            right: rect.right - containerPaddingRectRoot.left
        };
    }

    /**
     * Calculates the rect of the content-box. Similar to getBoundingClientRect, but excludes padding and borders - and
     * is much slower.
     *
     * @param   {HTMLElement} elem
     * @returns {ClientRect}
     */
    function getContentRect( elem ) {

        var rect = elem.getBoundingClientRect(),
            props = getCss( elem, [
                "borderTopWidth", "borderRightWidth", "borderBottomWidth", "borderLeftWidth",
                "paddingTop", "paddingRight", "paddingBottom", "paddingLeft"
            ], { toFloat: true } );

        return {
            top: rect.top + props.paddingTop + props.borderTopWidth,
            right: rect.right - ( props.paddingRight + props.borderRightWidth ),
            bottom: rect.bottom - ( props.paddingBottom + props.borderBottomWidth ),
            left: rect.left + props.paddingLeft + props.borderLeftWidth
        };
    }

    /**
     * Returns the top, left coordinates of the rect of the padding box (offset box).
     *
     * The coordinates match those of getBoundingClientRect, but exclude the borders.
     *
     * Does not care about bottom, right coordinates, in order to speed up the process.
     *
     * @param   {HTMLElement} elem
     * @returns {{ top: number, left: number }}
     */
    function getPaddingRectRoot( elem ) {

        var rect = elem.getBoundingClientRect(),
            props = getCss( elem, [
                "borderTopWidth", "borderLeftWidth"
            ], { toFloat: true } );

        return {
            top: rect.top + props.borderTopWidth,
            left: rect.left + props.borderLeftWidth
        };
    }

    /**
     * Returns the scroll bar state of the window. Helper for hasScrollbar().
     *
     * @param {Object} query
     * @param {Object} context
     *
     * @returns {{vertical: boolean, horizontal: boolean}}
     */
    function _windowHasScrollbar ( query, context ) {

        var windowInnerHeight, windowInnerWidth, windowProps,
            scrollbarWidth = $.scrollbarWidth(),
            result = {},
            doneX = ! query.getHorizontal,
            doneY = ! query.getVertical;

        // We may be able to take a shortcut. The window.innerWidth and -Height report the dimensions of the viewport
        // including scroll bars, and documentElement.clientWidth and -Height report them without scroll bars. That
        // gives the presence of a scroll bar away, as long as
        //
        // - the scroll bars actually take up space (width > 0)
        // - the browser supports window.innerWidth/Height (IE8, for instance, does not)
        // - the browser doesn't report a buggy value. FF has a bug which as only been fixed in FF25 (released 29 Oct
        //   2013). It manifests itself in a fictional return value of 10 for these properties. See
        //   * https://developer.mozilla.org/en-US/docs/Web/API/Window.innerWidth
        //   * https://developer.mozilla.org/en-US/docs/Web/API/Window.innerHeight
        //   * https://bugzilla.mozilla.org/show_bug.cgi?id=641188

        if ( query.getHorizontal && scrollbarWidth > 0 ) {
            windowInnerHeight = context.window.innerHeight;
            if ( windowInnerHeight > 10 ) {
                result.horizontal = windowInnerHeight > context.documentElement.clientHeight;
                doneX = true;
            }
        }

        if ( query.getVertical && scrollbarWidth > 0 ) {
            windowInnerWidth = context.window.innerWidth;
            if ( windowInnerWidth > 10 ) {
                result.vertical = windowInnerWidth > context.documentElement.clientWidth;
                doneY = true;
            }
        }

        if ( ! doneX || ! doneY ) {

            // Shortcut didn't work. We have to evaluate overflow settings, window and document size.

            windowProps = _getViewportOverflows( query, context ).window;

            // Handle the trivial cases first: window set to overflow: scroll or to overflow: hidden.
            if ( ! doneX && windowProps.overflowScrollX ) result.horizontal = doneX = true;
            if ( ! doneY && windowProps.overflowScrollY ) result.vertical = doneY = true;

            if ( ! doneX && windowProps.overflowHiddenX ) {
                result.horizontal = false;
                doneX = true;
            }

            if ( ! doneY && windowProps.overflowHiddenY ) {
                result.vertical = false;
                doneY = true;
            }

            // Handle the remaining overflow: auto case
            //
            // (There is no actual overflow: visible case for the viewport, see getAppliedViewportOverflows.)
            if ( ! doneX ) result.horizontal = context.documentElement.clientWidth < $.documentWidth( context.document );
            if ( ! doneY ) result.vertical = context.documentElement.clientHeight < $.documentHeight( context.document );

        }

        return result;

    }

    /**
     * Returns the applied overflow for the viewport (documentElement) and body in an aggregated `{ window: ...,
     * body: ...}` hash. Helper for hasScrollbar().
     *
     * If we deal with window or body scroll bars, we always need the settings for both body and window (documentElement)
     * because they are interdependent. See getAppliedViewportOverflows().
     *
     * @param {Object} query
     * @param {Object} context
     * @returns {{window: AppliedOverflow, body: AppliedOverflow}}
     */
    function _getViewportOverflows ( query, context ) {
        var windowProps, bodyProps,
            overflowPropNames = [ "overflow"],
            bodyOverflowPropNames = [ "overflow" ];

        if ( query.getHorizontal ) {
            overflowPropNames.push( "overflowX" );
            bodyOverflowPropNames.push( "overflowX" );
        }
        if ( query.getVertical ) {
            overflowPropNames.push( "overflowY" );
            bodyOverflowPropNames.push( "overflowY" );
        }

        windowProps = getCss( context.documentElement, overflowPropNames, { toLowerCase: true } );
        bodyProps = getCss( context.body, bodyOverflowPropNames, { toLowerCase: true } );

        return getAppliedViewportOverflows( windowProps, bodyProps );
    }

    /**
     * Determines the effective overflow setting of an element, separately for each axis, based on the `overflow`,
     * `overflowX` and `overflowY` properties of the element which must be passed in as a hash.
     *
     * Returns a hash of the computed results for overflowX, overflowY. Also adds boolean status properties to the hash
     * if the createBooleans flag is set. These are properties for mere convenience. They signal if a particular
     * overflow type applies (e.g. overflowHiddenX = true/false).
     *
     * ATTN The method does not take the special relation of body and documentElement into account. That is handled by
     * the more specific getAppliedViewportOverflows() function.
     *
     * The effective overflow setting is established as follows:
     *
     * - If a computed value for `overflow(X/Y)` exists, it gets applied to the axis.
     * - If not, the computed value of the general `overflow` setting gets applied to the axis.
     * - If there is no computed value at all, the overflow default gets applied to the axis. The default is
     *   "visible" in seemingly every browser out there. Falling back to the default should never be necessary,
     *   though, because there always is a computed value.
     *
     * @param {Object}        props            hash of element properties (computed values)
     * @param {string}        props.overflow
     * @param {string}        props.overflowX
     * @param {string}        props.overflowY
     * @param {boolean=false} createBooleans   if true, create the full set of boolean status properties, e.g.
     *                                         overflowVisibleX (true/false), overflowHiddenY (true/false) etc
     * @returns {AppliedOverflow}              hash of the computed results: overflowX, overflowY, optional boolean
     *                                         status properties
     */
    function getAppliedOverflows ( props, createBooleans ) {
        var status = {};

        // Establish the applied overflow (e.g. overflowX: "scroll")
        status.overflowX = props.overflowX || props.overflow || "visible";
        status.overflowY = props.overflowY || props.overflow || "visible";

        // Create the derived boolean status properties (e.g overflowScrollX: true)
        if ( createBooleans ) {
            $.each( [ "Visible", "Auto", "Scroll", "Hidden" ], function ( index, type ) {
                var lcType = type.toLowerCase();
                status["overflow" + type + "X"] = status.overflowX === lcType;
                status["overflow" + type + "Y"] = status.overflowY === lcType;
            } );
        }

        return status;
    }

    /**
     * Determines the effective overflow setting of the viewport and body, separately for each axis, based on the
     * `overflow`, `overflowX` and `overflowY` properties of the documentElement and body which must be passed in as a
     * hash.
     *
     * Returns the results for viewport and body in an aggregated `{ window: ..., body: ...}` hash.
     *
     * For the basic resolution mechanism, see getAppliedOverflows(). When determining the effective overflow, the
     * peculiarities of viewport and body are taken into account:
     *
     * - Viewport and body overflows are interdependent. If the nominal viewport overflow for a given axis is "visible",
     *   the viewport inherits the body overflow for that axis, and the body overflow is set to "visible". Curiously,
     *   that transfer is _not_ reflected in the computed values, it just manifests in behaviour.
     *
     * - Once that is done, if the viewport overflow is still "visible" for an axis, it is effectively turned into
     *   "auto". Scroll bars appear when the content overflows the viewport (ie, "auto" behaviour). Hence, this function
     *   will indeed report "auto". Again, the transformation is only manifest in behaviour, not in the computed values.
     *
     * - In iOS, if the effective overflow setting of the viewport is "hidden", it is ignored and treated as "auto".
     *   Content can still overflow the viewport, and scroll bars appear as needed.
     *
     *   Now, the catch. This behaviour is impossible to feature-detect. The computed values are not at all affected by
     *   it, and the results reported eg. for clientHeight, offsetHeight, scrollHeight of body and documentElement do
     *   not differ between Safari on iOS and, say, Chrome on the desktop. The numbers don't give the behaviour away.
     *
     *   So we have to resort to browser sniffing here. It sucks, but there is literally no other option.
     *
     * NB Additional status properties (see getAppliedOverflows) are always generated here.
     *
     * @param {Object} documentElementProps            hash of documentElement properties (computed values)
     * @param {string} documentElementProps.overflow
     * @param {string} documentElementProps.overflowX
     * @param {string} documentElementProps.overflowY
     *
     * @param {Object} bodyProps                       hash of body properties (computed values)
     * @param {string} bodyProps.overflow
     * @param {string} bodyProps.overflowX
     * @param {string} bodyProps.overflowY
     *
     * @returns {{window: AppliedOverflow, body: AppliedOverflow}}
     */
    function getAppliedViewportOverflows ( documentElementProps, bodyProps ) {
        var _window = getAppliedOverflows( documentElementProps, false ),
            body = getAppliedOverflows( bodyProps, false ),
            consolidated = { window: {}, body: {} };

        // Handle the interdependent relationship between body and window (documentElement) overflow
        if ( _window.overflowX === "visible" ) {
            // If the window overflow is set to "visible", body props get transferred to the window, body changes to
            // "visible". (Nothing really changes if both are set to "visible".)
            consolidated.body.overflowX = "visible";
            consolidated.window.overflowX = body.overflowX;
        } else {
            // No transfer of properties.
            // - If body overflow is "visible", it remains that way, and the window stays as it is.
            // - If body and window are set to properties other than "visible", they keep their divergent settings.
            consolidated.body.overflowX = body.overflowX;
            consolidated.window.overflowX = _window.overflowX;
        }

        // Repeat for overflowY
        if ( _window.overflowY === "visible" ) {
            consolidated.body.overflowY = "visible";
            consolidated.window.overflowY = body.overflowY;
        } else {
            consolidated.body.overflowY = body.overflowY;
            consolidated.window.overflowY = _window.overflowY;
        }

        // window.overflow(X/Y): "visible" actually means "auto" because scroll bars appear as needed; transform
        if ( consolidated.window.overflowX === "visible" ) consolidated.window.overflowX = "auto";
        if ( consolidated.window.overflowY === "visible" ) consolidated.window.overflowY = "auto";

        // In iOS, window.overflow(X/Y): "hidden" actually means "auto"; transform
        if ( isIOS() ) {
            if ( consolidated.window.overflowX === "hidden" ) consolidated.window.overflowX = "auto";
            if ( consolidated.window.overflowY === "hidden" ) consolidated.window.overflowY = "auto";
        }

        // Add the boolean status properties to the result
        consolidated.window = getAppliedOverflows( consolidated.window, true );
        consolidated.body = getAppliedOverflows( consolidated.body, true );

        return consolidated;
    }

    /**
     * Establishes the container and returns it in a jQuery wrapper.
     *
     * Resolves and normalizes the input, which may be a document, HTMLElement, window, or selector string. Corrects
     * likely mistakes, such as passing in a document or an iframe, rather than the corresponding window.
     *
     * @param {Window|Document|HTMLElement|HTMLIFrameElement|jQuery|string} container
     * @returns {jQuery}
     */
    function wrapContainer ( container ) {
        var $container,
            isJquery = container instanceof $;

        if ( ! isJquery && ! $.isWindow( container ) && ! container.nodeType && ! isString( container ) ) throw new Error( 'Invalid container: not a window, node, jQuery object or selector string' );

        $container = isJquery ? container : container === root ? $root : $( container );

        if ( !$container.length ) throw new Error( 'Invalid container: empty jQuery object' );

        container = $container[0];

        if ( container.nodeType === 9 ) {
            // Document is passed in, transform to window
            $container = wrapContainer( container.defaultView || container.parentWindow );
        } else if ( container.nodeType === 1 && container.tagName.toLowerCase() === "iframe" ) {
            // IFrame element is passed in, transform to IFrame content window
            $container = wrapContainer( container.contentWindow );
        }

        // Check if the container matches the requirements
        if ( !$.isWindow( $container[0] ) && $container.css( "overflow" ) === "visible" ) throw new Error( 'Invalid container: is set to overflow:visible. Containers must have the ability to obscure some of their content, otherwise the in-view test is pointless. Containers must be set to overflow:scroll/auto/hide, or be a window (or document, or iframe, as proxies for a window)' );

        return $container;
    }

    /**
     * Checks if the element is a descendant of the container, and throws an error otherwise. Also checks the type of
     * the element (must indeed be an element node).
     *
     * For performance reasons, this check should *not* be run on every element in a set.
     *
     * @param {HTMLElement}                 elem
     * @param {Window|Document|HTMLElement} container
     */
    function checkHierarchy ( elem, container ) {

        var elemIsContained;

        if ( elem.nodeType !== 1 ) throw new Error( "Invalid node: is not an element" );

        if ( $.isWindow( container ) ) {
            elemIsContained = elem.ownerDocument && container === ( elem.ownerDocument.defaultView || elem.ownerDocument.parentWindow );
        } else if ( container.nodeType === 9 ) {
            // We need a DOM element for this check, so we use the documentElement as a proxy if the container is a document.
            elemIsContained = $.contains( container.documentElement, elem );
        } else {
            elemIsContained = $.contains( container, elem );
        }

        if ( !elemIsContained ) throw new Error( "Invalid container: is not an ancestor of the element" );

    }

    /**
     * Spots likely option mistakes and throws appropriate errors.
     *
     * @param {Object} opts
     */
    function checkOptions ( opts ) {
        var isNum, isNumWithUnit;

        if ( opts.direction && !( opts.direction === 'vertical' || opts.direction === 'horizontal' || opts.direction === 'both' ) ) {
            throw new Error( 'Invalid option value: direction = "' + opts.direction + '"' );
        }

        if ( opts.box && !( opts.box === 'border-box' || opts.box === 'content-box' ) ) {
            throw new Error( 'Invalid option value: box = "' + opts.box + '"' );
        }

        if ( opts.tolerance !== undefined ) {
            isNum = isNumber( opts.tolerance );
            isNumWithUnit = isString( opts.tolerance ) && ( /^[+-]?\d*\.?\d+(px|%)?$/.test( opts.tolerance ) );
            if ( ! ( isNum || isNumWithUnit ) ) throw new Error( 'Invalid option value: tolerance = "' + opts.tolerance + '"' );
        }

    }

    /**
     * Gets the width of a jQuery-wrapped container, excluding scroll bars. Also supports quirks mode for window
     * containers, unlike jQuery's $( window ).width(). Makes use of caching if a cache object is provided.
     *
     * @param   {jQuery}  $container
     * @param   {boolean} isWindow    required to speed up the process
     * @param   {Object}  [cache]
     * @returns {number}
     */
    function getNetContainerWidth ( $container, isWindow, cache ) {
        var width;

        if ( cache && cache.netContainerWidth !== undefined ) {
            width = cache.netContainerWidth;
        } else {
            width = isWindow ?
                    getWindowDimension( $container, "Width" ) :
                    $container.innerWidth() - getContainerScrollbarWidths( $container, cache ).vertical;

            if ( cache ) cache.netContainerWidth = width;
        }

        return width;
    }

    /**
     * Gets the height of a jQuery-wrapped container, excluding scroll bars. Also supports quirks mode for window
     * containers, unlike jQuery's $( window ).height(). Makes use of caching if a cache object is provided.
     *
     * @param   {jQuery}  $container
     * @param   {boolean} isWindow    required to speed up the process
     * @param   {Object}  [cache]
     * @returns {number}
     */
    function getNetContainerHeight ( $container, isWindow, cache ) {
        var height;

        if ( cache && cache.netContainerHeight !== undefined ) {
            height = cache.netContainerHeight;
        } else {
            height = isWindow ?
                     getWindowDimension( $container, "Height" ) :
                     $container.innerHeight() - getContainerScrollbarWidths( $container, cache ).horizontal;

            if ( cache ) cache.netContainerHeight = height;
        }

        return height;
    }

    /**
     * Gets the effective scroll bar widths of a given container. Makes use of caching if a cache object is provided.
     *
     * @param   {jQuery} $container
     * @param   {Object} [cache]
     * @returns {Object}
     */
    function getContainerScrollbarWidths ( $container, cache ) {
        var containerScrollbarWidths;

        if ( cache && cache.containerScrollbarWidths ) {
            containerScrollbarWidths = cache.containerScrollbarWidths;
        } else {
            containerScrollbarWidths = effectiveScrollbarWith( $container );
            if ( cache ) cache.containerScrollbarWidths = containerScrollbarWidths;
        }

        return containerScrollbarWidths;
    }

    /**
     * Gets the width or height of a jQuery-wrapped window. Use it instead of $container.width(). Supports quirks mode,
     * unlike jQuery.
     *
     * Window dimensions are calculated as in Zakas, Professional Javascript (2012), p. 404. The standards mode part of
     * it is the same as in jQuery, too.
     *
     * @param {jQuery} $window
     * @param {string} dimension  "Width" or "Height" (capitalized!)
     * @returns {number}
     */
    function getWindowDimension ( $window, dimension ) {
        var doc = $window[0].document,
            property = "client" + dimension;

        return doc.compatMode === "BackCompat" ? doc.body[property] : doc.documentElement[property];
    }

    /**
     * Returns the computed style for a property, or an array of properties, as a hash.
     *
     * Building a CSS properties hash this way can be significantly faster than the more convenient, conventional jQuery
     * approach, $( elem ).css( propertiesArray ).
     *
     * ATTN
     * ====
     *
     * We are using an internal jQuery API here: $.css(). The current signature was introduced in jQuery 1.9.0. It may
     * break without warning with any change of the minor version.
     *
     * For that reason, the $.css API is monitored by the tests in api.jquery.css.spec.js which verify that it works as
     * expected.
     *
     * @param {HTMLElement}     elem
     * @param {string|string[]} properties
     * @param {Object}          [opts]
     * @param {boolean}         [opts.toLowerCase=false]  ensures return values in lower case
     * @param {boolean}         [opts.toFloat=false]      converts return values to numbers, using parseFloat
     *
     * @returns {Object}        property names and their values
     */
    function getCss ( elem, properties, opts ) {
        var i, length, name,
            props = {},
            _window = ( elem.ownerDocument.defaultView || elem.ownerDocument.parentWindow ),
            computedStyles = _useGetComputedStyle ? _window.getComputedStyle( elem, null ) : elem.currentStyle;

        opts || ( opts = {} );

        if ( ! $.isArray( properties ) ) properties = [ properties ];
        length = properties.length;

        for ( i = 0; i < length; i++ ) {
            name = properties[i];
            props[name] = $.css( elem, name, false, computedStyles );
            if ( opts.toLowerCase && props[name] && props[name].toLowerCase ) props[name] = props[name].toLowerCase();
            if ( opts.toFloat ) props[name] = parseFloat( props[name] );
        }

        return props;
    }

    /**
     * Returns the bounding client rect, including width and height properties. Ensures compatibility with IE8, which
     * supports getBoundingClientRect but doesn't calculate width and height.
     *
     * Use only when width and height are actually needed.
     *
     * Will be removed when IE8 support is dropped entirely.
     *
     * @param   {HTMLElement} elem
     * @returns {ClientRect}
     */
    function getBoundingClientRectCompat ( elem ) {
        var elemRect = elem.getBoundingClientRect();

        if ( elemRect.width === undefined || elemRect.height === undefined ) {
            // Fix for IE8
            elemRect = {
                top: elemRect.top,
                left: elemRect.left,
                bottom: elemRect.bottom,
                right: elemRect.right,
                width:  elemRect.right - elemRect.left,
                height: elemRect.bottom - elemRect.top
            };
        }

        return elemRect;
    }

    /**
     * Detects if the browser is on iOS. Works for Safari as well as other browsers, say, Chrome on iOS.
     *
     * Required for some iOS behaviour which can't be feature-detected in any way.
     *
     * @returns {boolean}
     */
    function isIOS () {
        if ( _isIOS === undefined ) _isIOS = (/iPad|iPhone|iPod/g).test( navigator.userAgent );
        return _isIOS;
    }

    /**
     * Calls parseFloat on each value. Useful for removing units from numeric values.
     *
     * @param   {Object} object
     * @returns {Object}
     */
    function toFloat ( object ) {
        var transformed =  {};

        $.map( object, function ( value, key ) {
            transformed[key] =  parseFloat( value );
        } );

        return transformed;
    }

    /**
     * Returns whether or not a value is of type number. Also rejects NaN as a number.
     *
     * NB This is not the same as $.isNumeric because $.isNumeric( "3" ) is true while isNumber( "3" ) is false.
     *
     * @param {*} value
     * @returns {boolean}
     */
    function isNumber ( value ) {
        // Done as in the Lodash compatibility build, but rejecting NaN as a number.
        var isNumeric = typeof value === 'number' || value && typeof value === 'object' && Object.prototype.toString.call( value ) === '[object Number]' || false;

        // Reject NaN before returning
        return isNumeric && value === +value;
    }

    function isString ( value ) {
        // Done as in the Lodash compatibility build
        return typeof value === 'string' || value && typeof value === 'object' && Object.prototype.toString.call(value) === '[object String]' || false;
    }

    /**
     * Custom types.
     *
     * For easier documentation and type inference.
     */

    /**
     * @name  AppliedOverflow
     * @type  {Object}
     *
     * @property {string}  overflowX
     * @property {string}  overflowY
     * @property {boolean} overflowVisibleX
     * @property {boolean} overflowVisibleY
     * @property {boolean} overflowAutoX
     * @property {boolean} overflowAutoY
     * @property {boolean} overflowScrollX
     * @property {boolean} overflowScrollY
     * @property {boolean} overflowHiddenX
     * @property {boolean} overflowHiddenY
     */


}( typeof jQuery !== "undefined" ? jQuery : $ ));
;(function($){
    function setupSliders() {
        $('.sonifex__slider').each(function (index, value) {
            /*
             * Function to get the currently visible slide count.
             */
            var slider = $(this);

            /*
             * Function to (re-)initialize all the variables for the slider.
             */
            function initialize() {
                var slidesVisible = 0; // This is how many slides we will scroll at once, max is 5 as the highest resolution is 5 slides.
                var slideCount = 0;
                var sliderSpeed = 250;
                var slideWidth = 0;

                slider.find('.sonifex__slider__items__item').each(function (index, value) {
                    // var visible = $(this).visible(false, false, 'horizontal');
                    var visible = $(this).isInView( $(this).closest( '.sonifex__slider__items' ), { partially: false, tolerance: 10, direction: 'horizontal'});
                    if (visible) {
                        slidesVisible++;
                    }
                    slideCount++;

                    if (visible && (slideWidth === undefined || slideWidth === 0)) {
                        slideWidth = $(this)[0].getBoundingClientRect().width; // jQuery Outerwidth does not return floating point.
                        // slideWidth = $(this).outerWidth();
                    }
                });

                slider.attr('data-slideCount', slideCount);
                slider.attr('data-slideWidth', slideWidth);
                slider.attr('data-slidesVisible', slidesVisible);
                slider.attr('data-sliderSpeed', sliderSpeed);

                if (!slider[0].hasAttribute('data-slideindex')) {
                    slider.attr('data-slideindex', 0);
                }
            }

            function slideToIndex(slider, index) {
                if (index <= 0) {
                    index = 0;
                } else {
                    index = Math.min(index, slider.attr('data-slideCount') - slider.attr('data-slidesVisible'));
                }
                slider.find('.sonifex__slider__items__item').first().animate({
                    "margin-left": (-(index) * (slider.attr('data-slideWidth')))
                }, slider.attr('data-sliderSpeed'));
                slider.attr('data-slideindex', index);
            }

            /*
             * When the window is resized we need to recalculate the visible slides.
             */
            var resizeTimer;
            $(window).on('resize', function(e) {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function() {
                    initialize();
                    slideToIndex(slider, slider.attr('data-slideindex'));
                }, 250);
            });

            function scrollRight(slider) {
                var newIndex = parseInt(slider.attr('data-slideindex')) + parseInt(slider.attr('data-slidesVisible'));
                slideToIndex(slider, newIndex);
            }

            function scrollLeft(slider) {
                var newIndex = parseInt(slider.attr('data-slideindex')) - parseInt(slider.attr('data-slidesVisible'));
                slideToIndex(slider, newIndex);
            }

            slider.find('.sonifex__slider__controls--prev>a').first().click(function (e) {
                e.preventDefault();
                scrollLeft(slider);
            });

            slider.find('.sonifex__slider__controls--next>a').first().click(function (e) {
                e.preventDefault();
                scrollRight(slider);
            });

            slider.on('custom', function(event) {
                initialize();
            });

            initialize();
        });
    }
    /*
     * On page read.
     */
    $(window).load(function(){
        setupSliders();
    });

    /*
         * On page read.
         */
    $(window).load(function(){
        var openTab = 0;
        $('.sonifex__slider__click').click(function (e) {
            e.preventDefault();
            var tabID = $(this).attr('data-tab');
            var tabElement;
            if (openTab !== tabID) {
                tabElement = $('.dropdown-tab-' + openTab).first();
                if (openTab !== 0) {
                    tabElement.slideUp("fast", function () {
                        tabElement = $('.dropdown-tab-' + tabID).first();
                        tabElement.slideDown();
                        tabElement.find('.sonifex__slider').first().trigger("custom", []);
                    });
                } else {
                    tabElement = $('.dropdown-tab-' + tabID).first();
                    tabElement.slideDown();
                    tabElement.find('.sonifex__slider').first().trigger("custom", []);
                }
            } else {
                tabElement = $('.dropdown-tab-' + openTab).first();
                tabElement.slideUp();
            }
            openTab = tabID;
        });
    });
}(jQuery));

